import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";

import { addCountry, obtenerCountries } from "../../../../API/Global/Countries/CountriesRequests";
import Loader from "../../../../Components/Loader/Loader";
import { InputNumber } from "primereact/inputnumber";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";

const CountriesCrudModal = ({
  pais,
  paisesDialog,
  setPaisesDialog,
  toastRef,
  getPaises,
  modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);
  const [countryList, setCountryList] = useState("");
  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext);
  const [show, setShow] = useState(false);

  const initialValues = {
    IdCountry: -1,
    Iso: "",
    Country: "",
    Iso3: "",
    NumCode: "",
    PhoneCode: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

    const getValoresIniciales = async () => {
      setLoading(true)
      const c = await obtenerCountries();
      setCountryList(c);

      setValues({
        ...pais,
      });
      setLoading(false)
    };

  const onHide = () => {
    setPaisesDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Country) {
      error.Country = true;
      error.error = true;
    }
    if (!values.Iso) {
      error.Iso = true;
      error.error = true;
    }
    if (!values.Iso3) {
      error.Iso3 = true;
      error.error = true;
    }
    if (!values.NumCode) {
      error.NumCode = true;
      error.error = true;
    }
    if (!values.PhoneCode) {
      error.PhoneCode = true;
      error.error = true;
    }
    setError(error);
    console.log(error);
    return error;
  };

  const agregarCountry = async () => {
    const e = verificarInfo();

    if (!e.error) {

      const existingCountry = countryList.find((cur) => cur.Country === values?.Country);
      if (
        existingCountry &&
        (modo === "Crear" || existingCountry.IdCountry !== values.IdCountry)
      ) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe un País con ese nombre"
        );
      }else{
        const a = {
          IdCountry: values?.IdCountry,
          Country: values.Country.toUpperCase(),
          Iso: values.Iso,
          Iso3: values.Iso3,
          NumCode: values.NumCode,
          PhoneCode: values.PhoneCode,
          IdUserCreate: userAuth?.IdUser
        }

        const dialogTitle = modo === "Crear" ? "Registro Guardado exitosamente." : "Registro Actualizado exitosamente.";
        
        const resultado = await addCountry(a);

        setLoading(true)
        toastShow(toastRef, "success", "Datos Agregados", dialogTitle);
        toastShow(toast, "success", "Datos Agregados", dialogTitle);
        getPaises();
        setTimeout(() => {
          onHide();
          setLoading(false)
        }, 1000);
      }
    } else {
      toastShow(toast, "error", "Error", "Error al guardar la informacion");
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarCountry();
          } else {
            agregarCountry();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (paisesDialog) {
      getValoresIniciales();
    }
  }, [paisesDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar País" : "Modificar País";

  return (
    <div>
      <Dialog
        visible={paisesDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="DialogP">
          <Loader loading={loading} querySelector={"#DialogP"}/>
          <Toast ref={toast} style={{ zIndex: 50000 }} />
          <ConfirmDialog />

          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Country"
                  value={values.Country}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Country ? "p-invalid" : ""}
                />
                <label htmlFor="Country">País</label>
                {error.Country && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Nombre del País es requerido.
                  </small>
                )}
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Iso"
                  value={values.Iso}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Iso ? "p-invalid" : ""}
                />
                <label htmlFor="Iso">ISO</label>
                {error.Iso && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    ISO es requerido.
                  </small>
                )}
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Iso3"
                  value={values.Iso3}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Iso3 ? "p-invalid" : ""}
                />
                <label htmlFor="Iso3">ISO 3</label>
                {error.Iso3 && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    ISO 3 es requerido.
                  </small>
                )}
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="PhoneCode"
                  value={values.PhoneCode}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.PhoneCode ? "p-invalid" : ""}
                />
                <label htmlFor="PhoneCode">Código Telefónico</label>
                {error.Iso && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Codigo Telefónico es requerido.
                  </small>
                )}
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputNumber
                  name="NumCode"
                  value={values.NumCode}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.NumCode ? "p-invalid" : ""}
                  useGrouping={false}
                />
                <label htmlFor="NumCode">Código Numérico</label>
                {error.Country && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Código Numérico es requerido.
                  </small>
                )}
              </span>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CountriesCrudModal;
